<template>
  <div class="special-detail">
    <div class="special-detail-content">
      <div class="detail-info" v-if="subjectInfo">
        <div class="left-img flex-center">
          <el-image class="img_box" :src="subjectInfo.picFile">
            <div slot="error" class="image-slot">
              <img class="img_box" src="@/assets/images/default_img.jpg" />
            </div>
          </el-image>
        </div>
        <div class="right-info">
          <div class="title">
            {{ subjectInfo.subjectName }}
          </div>
          <div class="label" v-if="keyword != ''">
            <span v-for="(item, index) in keyword" :key="index">{{
              item
            }}</span>
          </div>
          <div class="price" v-if="subjectInfo.priceRadio != 3">
            <span v-if="!isShop">{{
              subjectInfo.sellingPrice | tofixed2("￥")
            }}</span>
            <span v-if="isShop" class="havebuy">已购买</span>
            <span
              v-if="subjectInfo.price > 0"
              :class="subjectInfo.price == 0 ? 'yprice2' : 'yprice'"
              >{{ subjectInfo.price | tofixed2("￥") }}</span
            >
          </div>
          <div class="price price_no" v-else>
            如需购买，请拨打联系电话: 010-68182532
          </div>
          <div class="sales">
            <div class="sales-volume">
              <img src="@/assets/icon/销量预测.png" alt="" />
              销量：{{ subjectInfo.salesVolume }}
            </div>
            <div class="goods-score">
              商品评分：
              <el-rate
                v-model="subjectInfo.averageScore"
                disabled
                show-score
                text-color="#D81E06"
                :colors="colors"
                score-template="{value}分"
              >
              </el-rate>
            </div>
          </div>
          <div class="integral-share">
            <div class="integral">
              <img src="@/assets/icon/积分.png" alt="" />
              赠送积分：{{
                subjectInfo.integralNum == null || subjectInfo.integralNum == ""
                  ? "-"
                  : subjectInfo.integralNum
              }}
            </div>
            <div class="share-img">
              分享到
              <share :config="$store.state.read.config" />
              <!-- <img @click="share" src="@/assets/icon/qq.png" alt="" />
              <img @click="share" src="@/assets/icon/wechat.png" alt="" />
              <img @click="share" src="@/assets/icon/weibo.png" alt="" /> -->
            </div>
          </div>
          <el-divider></el-divider>
          <!-- <el-button type="primary" @click="toReadOnline()">在线试读</el-button> -->
          <el-button
            type="primary"
            v-if="!isShop && subjectInfo.priceRadio != 3"
            @click="toPay()"
            >立即购买</el-button
          >
          <el-button type="info" plain disabled v-if="isShop">已购买</el-button>
          <p class="special-p">温馨提示：此类商品不支持退换货</p>
        </div>
      </div>
      <div class="book-recommend">
        <div>
          <div class="left-resource">
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane name="first">
                <span slot="label">商品列表 ( {{ total1 }} )</span>
                <!-- <div class="book-putAway">
                  <div class="book">
                    <img src="@/assets/icon/book.png" alt="" />
                    图书
                  </div>
                  <div class="put-away" @click="controlShow">
                    {{ showBook ? "收起" : "展开" }}
                    <img src="@/assets/icon/double-arrow.png" alt="" />
                  </div>
                </div> -->
                <booklist-box
                  :data-list="bookList"
                  :show-book="showBook"
                  :subject-id="subjectId"
                  :show-editor="showEditor"
                  :pay-type="payType"
                  :goodsTypeList="goodsTypeList"
                ></booklist-box>
                <noData v-if="total1 == 0"></noData>
                <div class="pagination-box" v-show="total1 > 0 && showBook">
                  <el-pagination
                    class="ou-pagination"
                    background
                    hide-on-single-page
                    @size-change="handleSizeChange1"
                    @current-change="handleCurrentChange1"
                    :current-page="queryParams1.pageNum"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="queryParams1.pageSize"
                    layout="total, prev, pager, next, sizes, jumper, slot"
                    :total="total1"
                  >
                    <el-button @click="getList2()" class="ou-page-go"
                      >GO</el-button
                    >
                  </el-pagination>
                </div>
              </el-tab-pane>
              <el-tab-pane name="second">
                <span slot="label">内容简介</span>
                <div class="book-content">
                  <div
                    class="content-info ql-editor ql-snow"
                    v-html="subjectInfo.briefContent"
                  ></div>
                </div>
                <noData
                  v-if="
                    subjectInfo.briefContent == null ||
                    subjectInfo.briefContent == ''
                  "
                ></noData>
              </el-tab-pane>
              <el-tab-pane name="third">
                <span slot="label">评价 ( {{ total }} )</span>
                <div class="evaluate-list">
                  <div
                    class="evaluate-box"
                    v-for="(item, index) in evaluateList"
                    :key="index"
                  >
                    <div class="user-img">
                      <img
                        :src="
                          item.avatar == '' || item.avatar == null
                            ? defaultAvatar
                            : item.avatar
                        "
                        alt=""
                      />
                    </div>
                    <div class="evaluate-info">
                      <div class="name-score">
                        <div class="name">
                          {{ item.truename }}
                        </div>
                        <div class="score">
                          <el-rate
                            v-model="item.score"
                            disabled
                            show-score
                            text-color="#D81E06"
                            :colors="colors"
                            score-template="{value}分"
                          >
                          </el-rate>
                        </div>
                      </div>
                      <div class="evaluate-content">
                        {{ item.content }}
                      </div>
                      <div class="time-report">
                        <div class="time">{{ item.createTime }}</div>
                        <div class="report-icon" @click="handleReport(item)">
                          <img
                            :src="
                              require('@/assets/icon/report' +
                                (item.reportCount == 0 ? '.png' : 'ed.png'))
                            "
                            alt=""
                          />
                          <span :class="item.reportCount == 0 ? '' : 'red'">{{
                            item.reportCount == 0 ? "举报" : "已举报"
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <noData v-if="total == 0"></noData>
                  <div class="pagination-box" v-show="total > 0">
                    <el-pagination
                      class="ou-pagination"
                      background
                      hide-on-single-page
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="queryParams.pageNum"
                      :page-sizes="[10, 20, 30, 40, 50]"
                      :page-size="queryParams.pageSize"
                      layout="total, prev, pager, next, sizes, jumper, slot"
                      :total="total"
                    >
                      <el-button @click="getList3()" class="ou-page-go"
                        >GO</el-button
                      >
                    </el-pagination>
                  </div>
                  <el-dialog title="举报" :visible.sync="dialogFormVisible">
                    <!-- 举报对话框 -->
                    <el-form :model="form">
                      <div class="report-title">
                        <span>举报内容</span>
                      </div>
                      <div>
                        <el-input
                          v-model.trim="form.reportContent"
                          placeholder="请输入举报内容"
                          type="textarea"
                          :rows="5"
                          auto-complete="off"
                          maxlength="250"
                          show-word-limit
                        />
                      </div>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                      <el-button @click="cancelReport">取 消</el-button>
                      <el-button type="primary" @click="submitReport()"
                        >确 定</el-button
                      >
                    </div>
                  </el-dialog>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <div class="right-recommend">
          <div class="recommend-special" v-if="recommendSubject.length > 0">
            <div class="title theme-title">推荐专题</div>
            <div
              class="recommend-book"
              v-for="(item, index) in recommendSubject"
              :key="index"
            >
              <div class="img flex-center" @click="toDetail(item.subjectId)">
                <img :src="item.cover" alt="" />
              </div>
              <el-tooltip
                :content="item.subjectName"
                placement="top"
                v-ak-tooltip-auto-show
              >
                <div class="book-title" @click="toDetail(item.subjectId)">
                  {{ item.subjectName }}
                </div>
              </el-tooltip>

              <div class="book-info">
                <div class="left-label">共{{ item.resourcesNun }}个商品</div>
                <div class="price">
                  <!-- <el-tooltip
                    :content="item.sellingPrice.toString()"
                    placement="top"
                    v-ak-tooltip-auto-show
                  > -->
                  <span class="sellprice ellipsis-aRow">{{
                    item.sellingPrice | tofixed2("￥")
                  }}</span>
                  <!-- </el-tooltip> -->
                  <!-- <el-tooltip
                    :content="item.price.toString()"
                    placement="top"
                    v-ak-tooltip-auto-show
                  > -->
                  <span
                    class="ellipsis-aRow"
                    :class="item.price == 0 ? 'yprice2' : 'yprice'"
                    >{{ item.price | tofixed2("￥") }}</span
                  >
                  <!-- </el-tooltip> -->
                </div>
              </div>
            </div>
          </div>
          <div class="recommend-resource" v-if="recommendGoodsOne.length > 0">
            <div class="title theme-title">推荐商品</div>
            <div
              class="recommend-book"
              v-for="(item, index) in recommendGoodsOne"
              :key="index"
            >
              <div
                class="img flex-center"
                @click="toDetail1(item.goodsId, item.goodsType)"
              >
                <img :src="item.cover" alt="" />
              </div>
              <div
                class="book-title"
                @click="toDetail1(item.goodsId, item.goodsType)"
              >
                <img src="@/assets/icon/title.png" alt="" />
                <el-tooltip
                  :content="item.goodsTitle"
                  placement="top"
                  v-ak-tooltip-auto-show
                >
                  <p>{{ item.goodsTitle }}</p>
                </el-tooltip>
              </div>
              <div class="catalogue">
                <div
                  class="content-item"
                  v-for="(item, index) in recommendGoods"
                  :key="index"
                  @click="toDetail1(item.goodsId, item.goodsType)"
                >
                  <el-tooltip
                    :content="item.goodsTitle"
                    placement="top"
                    v-ak-tooltip-auto-show
                  >
                    <span class="ellipsis-aRow">{{ item.goodsTitle }}</span>
                  </el-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  specialDetailInfo,
  listResource,
  listEvaluate,
  recommendSubject,
  recommendGoods,
} from "@/api/special/special";
import "quill/dist/quill.core.css"; // 引入样式
import "quill/dist/quill.snow.css"; // snow theme
import "quill/dist/quill.bubble.css"; // bubble theme
import {
  reportComment,
  checkIsBuy,
  teachingAttrList,
  SelSubjectStatus,
} from "@/api/bookstore/bookstore";
import booklistBox from "@/components/booklistBox.vue";
import noData from "@/components/noData.vue";
export default {
  data() {
    return {
      isShop: false,
      showEditor: true,
      showBook: true,
      defaultAvatar: require("@/assets/images/default-avatar.jpg"),
      colors: ["#D81E06", "#D81E06", "#D81E06"],
      subjectId: null,
      total: 0,
      total1: 0,
      activeName: "first",
      subjectInfo: {},
      bookList: [],
      evaluateList: [],
      recommendGoods: [], //推荐商品
      recommendSubject: [], //推荐专题,
      recommendGoodsOne: [],
      keyword: [],
      //查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        subjectId: null,
        type: "subject",
      },
      // 商品列表查询参数
      queryParams1: {
        pageNum: 1,
        pageSize: 10,
        subjectId: null,
      },
      dialogFormVisible: false,
      //举报对话框参数
      form: {
        evaluateId: 0,
        orderId: 0,
        relevanceId: 0,
        reportContent: "",
      },
      payType: "subject",
      goodsTypeList: [],
    };
  },
  components: { booklistBox, noData },
  created() {
    this.$store.commit("subjectId_special", this.$route.query.subjectId);
    this.subjectId = this.$route.query.subjectId;
    this.getList();
    this.getList2();
    this.getList3();
    teachingAttrList("oc_resource_file").then((res) => {
      this.goodsTypeList = res.data;
    });
  },
  watch: {
    //监听路由变化
    $route() {
      if (this.$route.query.subjectId) {
        this.$store.commit("subjectId_special", this.$route.query.subjectId);
        this.subjectId = this.$route.query.subjectId;
        this.getList();
        this.getList2();
        this.getList3();
      }
    },
  },
  methods: {
    //获取详细信息
    getList() {
      //获取商品基本信息
      specialDetailInfo(this.subjectId).then((res) => {
        if (res.code == 200) {
          this.subjectInfo = res.data;
          !this.subjectInfo.averageScore
            ? (this.subjectInfo.averageScore = 5)
            : this.subjectInfo.averageScore;
          //关键字
          this.keyword = res.data.keyword.split(",");
          // this.recommendSubject = res.data.recommendSubject;
          //取前两个作为推荐专题的内容
          // this.recommendSubject = res.data.recommendSubject.slice(0, 2);
          let userId = this.$store.getters.userId;
          if (userId) {
            this.isPaySubject();
          }
          this.$nextTick(() => {
            // this.$forceUpdate();
          });
        }
      });
      // 获取推荐专题
      recommendSubject(this.subjectId).then((res) => {
        if (res.code == 200) {
          this.recommendSubject = res.data;
        }
      });
      //获取推荐商品
      recommendGoods(this.subjectId).then((res) => {
        if (res.code == 200) {
          this.recommendGoodsOne = res.data.slice(0, 1);
          this.recommendGoods = res.data.slice(1, 5);
        }
      });
    },
    //跳转到对应专题
    toDetail(id) {
      this.$router.push({
        path: "/special/specialDetail",
        query: { subjectId: id },
      });
    },
    //跳转到对应商品
    toDetail1(id, type) {
      // console.log(id,type)
      this.$router.push({
        path: "/bookstore/bookstoreDetail",
        query: { goodsId: id, goodsType: type },
      });
    },
    //跳转到订单页
    toPay() {
      let userId = this.$store.getters.userId;
      if (!userId) {
        this.$store.commit("SET_REDIRECTPARAMS", { subjectId: this.subjectId });
        this.$router.push({
          path: "/login",
          query: {
            redirectPath: "/special/specialDetail",
          },
        });
      } else {
        //判断是否已经购买该专题
        checkIsBuy({ relevanceId: this.subjectId, type: this.payType }).then(
          (res) => {
            console.log("是否已购买响应", res);
            if (res.data === "2") {
              this.$message.error("数据异常");
              return;
            }
            if (res.data === "1") {
              SelSubjectStatus(this.subjectId).then((subjectState) => {
                if (subjectState.data.auditStatus == 2) {
                  this.$router.push({
                    path: "/submitOrder/index",
                    query: { id: this.subjectId, from: "special" },
                  });
                  this.isShop = false;
                } else {
                  this.$message("该专题已下架");
                }
              });
            } else {
              this.isShop = true;
              // this.$message("该专题已购买无需重复购买");
            }
          }
        );
      }
    },
    isPaySubject() {
      //判断是否已经购买该专题
      checkIsBuy({ relevanceId: this.subjectId, type: this.payType }).then(
        (res) => {
          if (res.data === "2") {
            this.$message.error("数据异常");
            return;
          }
          if (res.data === "1") {
            this.isShop = false;
          } else {
            this.isShop = true;
            // this.$message("该专题已购买无需重复购买");
          }
        }
      );
    },
    //获取商品列表
    getList2() {
      this.queryParams1.subjectId = this.subjectId;
      listResource(this.queryParams1).then((res) => {
        if (res.code == 200) {
          this.bookList = res.rows;
          // console.log(this.bookList)
          this.total1 = res.total;
        }
      });
    },
    //获取评价列表
    getList3() {
      this.queryParams.subjectId = this.subjectId;
      listEvaluate(this.queryParams).then((res) => {
        if (res.code == 200) {
          this.evaluateList = res.rows;
          this.evaluateList.forEach((item) => {
            item.score = Number(item.score);
          });
          this.total = res.total;
        }
      });
    },
    handleClick(tab) {
      if (tab.index == 2) {
        this.getList3();
      }
    },
    //打开举报对话框
    handleReport(item) {
      this.form = {};
      this.form.evaluateId = item.id;
      this.form.orderId = item.orderId;
      this.form.relevanceId = item.relevanceId;
      this.dialogFormVisible = true;
    },
    //提交举报
    submitReport() {
      if (this.form.reportContent == null || this.form.reportContent == "") {
        this.$message("举报内容不能为空");
        return;
      } else {
        reportComment(this.form).then((res) => {
          if (res.code == 200) {
            this.$message({
              message: "举报成功",
              type: "success",
            });
            this.dialogFormVisible = false;
            this.getList3();
          }
        });
      }
    },
    //取消举报
    cancelReport() {
      this.dialogFormVisible = false;
      this.form = {};
    },
    // 控制商品列表的显示和隐藏
    controlShow() {
      this.showBook = !this.showBook;
    },
    //每页条数
    handleSizeChange1(val) {
      this.queryParams1.pageSize = val;
      this.getList2();
    },
    //当前页面
    handleCurrentChange1(val) {
      this.queryParams1.pageNum = val;
      this.getList2();
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList3();
    },
    //当前页面
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList3();
    },
    // toReadOnline() {
    //   this.$router.push({
    //     path: "/onlineReading",
    //     query: { goodId: this.goodId },
    //   });
    // },
    share() {
      this.$alert("此功能正在开发中，敬请期待", "提示信息");
    },
  },
};
</script>
<style scoped lang='scss'>
.special-detail {
  .special-detail-content {
    // height: 100%;
    min-height: calc(100vh - 310px);
    padding-bottom: 40px;
    // background: #f2f2f2;
    .detail-info {
      width: 1400px;
      min-height: 342px;
      background: #fffefd;
      margin: 0 auto 16px;
      padding: 20px 25px;
      display: flex;
      // align-items: center;
      box-sizing: border-box;
      .left-img {
        width: 400px;
        height: 300px;
        box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
        margin-right: 48px;
        img {
          // max-width: 100%;
          // max-height: 100%;
          // object-fit: scale-down;
          width: 100%;
          height: 100%;
        }
      }
      .right-info {
        width: 900px;
        .title {
          line-height: 17px;
          margin-top: 15px;
          width: 800px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-bottom: 18px;
          height: 16px;
        }
        .label {
          // height: 33px;
          display: flex;
          align-items: center;
          margin-bottom: 35px;
          flex-wrap: wrap;
          span {
            // line-height: 14px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            // height: 28px;
            background: #f2f2f2;
            border-radius: 6px;
            padding: 7px 10px;
            margin-right: 16px;
            box-sizing: border-box;
            display: block;
            margin-bottom: 8px;
          }
          span:last-child {
            margin-right: 0;
          }
        }
        .price {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #ff5353;
          display: flex;
          align-items: center;
          margin-bottom: 20px;
          .havebuy {
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #70b603;
          }
          .yprice {
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 400;
            text-decoration: line-through;
            color: #999999;
            margin-left: 15px;
          }
          .yprice2 {
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 400;
            // text-decoration: none;
            text-decoration: line-through;
            color: #999999;
            margin-left: 15px;
          }
        }
        .price_no {
          font-size: 14px;
          color: #999999;
        }
        .sales {
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 19px;
          .sales-volume {
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #999999;
            img {
              width: 12px;
              height: 12px;
            }
          }
          .goods-score {
            display: flex;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            align-items: center;
          }
        }
        .integral-share {
          display: flex;
          align-items: center;
          height: 18px;
          justify-content: space-between;
          .integral {
            font-size: 13px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #999999;
          }
          .share-img {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #999999;
            display: flex;
            align-items: center;
            img {
              width: 18px;
              height: 18px;
              margin-left: 8px;
              cursor: pointer;
            }
          }
        }
        .el-divider--horizontal {
          margin: 17px 0 12px;
        }
        .el-button {
          width: 200px;
          margin-bottom: 10px;
        }
        p {
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #999999;
          margin-bottom: 10px;
        }
      }
    }
    .book-recommend {
      width: 1400px;
      min-height: 500px;
      margin: 0 auto;
      display: flex;
      box-sizing: border-box;
      .left-resource {
        width: 1080px;
        min-height: 250px;
        background: #fffefd;
        margin-right: 16px;
        box-sizing: border-box;
        padding: 7px 22px 30px 18px;
        .el-tabs {
          .el-tabs__item {
            span {
              padding: 0 18px;
              font-size: 16px;
            }
          }
        }
        .book-putAway {
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 23px;
          margin-top: 15px;
          .book {
            display: flex;
            align-items: center;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
            height: 23px;
            img {
              width: 21px;
              height: 21px;
              margin-right: 7px;
            }
          }
          .put-away {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #33649f;
            height: 23px;
            cursor: pointer;
            img {
              width: 13px;
              height: 14px;
              margin-left: 7px;
            }
          }
        }
        .book-content {
          box-sizing: border-box;
          padding: 0 18px 0;
          .content-info {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 26px;
            ::v-deep img {
              max-width: 100%;
            }
          }
        }
        .evaluate-list {
          .evaluate-box {
            display: flex;
            padding: 15px 0;
            box-sizing: border-box;
            border-bottom: 1px solid #f2f2f2;
            .user-img {
              border-radius: 50%;
              width: 40px;
              height: 40px;
              margin-right: 16px;
              img {
                max-width: 40px;
                max-height: 40px;
                border-radius: 50%;
              }
            }
            .evaluate-info {
              width: 1000px;
              .name-score {
                height: 20px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 11px;
                .name {
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #333333;
                }
              }
              .evaluate-content {
                line-height: 17px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #333333;
                margin-bottom: 15px;
                word-break: break-all;
              }
              .time-report {
                height: 12px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .time {
                  font-size: 12px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #999999;
                }
                .report-icon {
                  font-size: 12px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  color: #999999;
                  cursor: pointer;
                  img {
                    width: 11px;
                    height: 11px;
                  }
                  .red {
                    color: #d81e06;
                  }
                }
              }
            }
          }
        }
      }
      .right-recommend {
        width: 304px;
        .recommend-special {
          width: 304px;
          min-height: 340px;
          background: #fffefd;
          margin-bottom: 16px;
          box-sizing: border-box;
          padding: 13px 22px 10px;
          .title {
            font-weight: bold;
          }
          .recommend-book {
            margin-top: 16px;
            width: 260px;
            height: 280px;
            background: #ffffff;
            border: 1px solid #f2f2f2;
            .img {
              width: 260px;
              height: 195px;
              cursor: pointer;
              img {
                // max-width: 100%;
                // max-height: 100%;
                // object-fit: scale-down;
                width: 100%;
                height: 100%;
              }
            }
            .book-title {
              line-height: 18px;
              height: 16px;
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #333333;
              margin: 15px 0;
              margin-left: 5px;
              width: 250px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
              cursor: pointer;
            }
            .book-info {
              display: flex;
              align-items: center;
              justify-content: space-between;
              height: 28px;
              .left-label {
                width: 100px;
                height: 28px;
                background: #ffffff;
                border: 1px solid #0081ce;
                border-radius: 6px;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #0081ce;
                text-align: center;
                line-height: 28px;
                margin-left: 6px;
              }
              .price {
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #ff5353;
                margin-right: 10px;
                display: flex;
                align-items: center;
                .sellprice {
                  display: inline-block;
                  max-width: 82px;
                }
                .yprice {
                  margin-left: 4px;
                  font-size: 12px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  text-decoration: line-through;
                  color: #999999;
                  display: inline-block;
                  max-width: 64px;
                }
                .yprice2 {
                  margin-left: 4px;
                  font-size: 12px;
                  font-family: PingFang SC;
                  font-weight: 400;
                  // text-decoration: none;
                  text-decoration: line-through;
                  color: #999999;
                  display: inline-block;
                  max-width: 64px;
                }
              }
            }
          }
        }
        .recommend-resource {
          width: 304px;
          min-height: 250px;
          background: #fffefd;
          box-sizing: border-box;
          padding: 13px 22px 10px;
          .title {
            font-weight: bold;
          }
          .title::before {
            background: #f6a200;
          }
          .recommend-book {
            margin-top: 14px;
            .img {
              width: 143px;
              height: 143px;
              display: flex;
              margin: 0 auto;
              align-items: center;
              justify-content: center;
              background: #ffffff;
              border: 1px solid #f2f2f2;
              margin-bottom: 16px;
              cursor: pointer;
              img {
                width: 100%;
                height: 100%;
                // max-width: 100%;
                // max-height: 100%;
                // object-fit: scale-down;
              }
            }
            .book-title {
              display: flex;
              align-items: center;
              max-width: 280px;
              justify-content: center;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #333333;
              margin-bottom: 11px;
              cursor: pointer;
              p {
                max-width: 216px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
              }
              img {
                width: 27px;
                height: 20px;
                margin-right: 4px;
              }
            }
            .catalogue {
              .content-item {
                height: 43px;
                box-sizing: border-box;
                font-size: 14px;
                font-family: PingFang SC;
                font-weight: 400;
                color: #333333;
                border-top: 1px solid #f2f2f2;
                padding: 14px 16px;
                position: relative;
                width: 250px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
                span {
                  display: inline-block;
                  max-width: 240px;
                  height: 14px;
                  line-height: 14px;
                }
              }
              .content-item::before {
                content: "";
                display: block;
                width: 5px;
                height: 5px;
                background: #0084d2;
                border-radius: 50%;
                position: absolute;
                left: 4px;
                top: 19px;
              }
              .content-item:last-child {
                padding-bottom: 0;
              }
            }
          }
        }
      }
    }
  }
}
.pagination-box {
  margin-top: 30px;
  text-align: right;
}
::v-deep .el-dialog {
  width: 40%;
  .el-dialog__header {
    background: #f0f2f5;
  }
  .report-title {
    margin-bottom: 10px;
  }
}
::v-deep .el-textarea__inner {
  resize: none;
}
.el-button--success:active {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
.el-button--success:hover {
  color: #fff;
  background-color: #67c23a;
  border-color: #67c23a;
}
</style>
